<div class="scorm-container">
  <iframe
    #scormFrame
    [src]="safeScormUrl()"
    (load)="onIframeLoad()"
    class="scorm-iframe"
    title="SCORM content"
  ></iframe>

  <!-- Embedded PDF/video opens in a full-bleed overlay OVER the still-mounted
       course, so closing it returns the learner to the exact same place. -->
  @if (activeAsset(); as asset) {
    <div class="scorm-embed">
      <div class="scorm-embed__header">
        <button
          type="button"
          class="scorm-embed__close"
          aria-label="Close"
          (click)="closeDialog()"
        >
          ✕
        </button>
      </div>
      <div class="scorm-embed__body" [style.--embedded-scrollbar-gap.px]="embeddedScrollbarGapPx()">
        @if (asset.kind === 'pdf') {
          <pdf-viewer
            class="scorm-embed__pdf"
            [src]="asset.url"
            (pagesLoaded)="onPdfPagesLoaded($event)"
            (pageChange)="onPdfPageChange($event)"
            (pagesLoaded)="onEmbeddedPagesLoaded($event)"
            (isScrollable)="onEmbeddedScrollableChange($event)"
          />
          @if (embeddedTotalPages() > 1) {
            <button
              qai-button
              type="button"
              [shape]="'circle'"
              [kind]="'tertiary'"
              [size]="'small'"
              [disabled]="!canGoPreviousEmbedded"
              (click)="previousEmbeddedPage()"
              class="nav-button nav-left"
              aria-label="Previous page"
            >
              <qai-icon kind="chevron-left" positionStart />
            </button>
            <button
              qai-button
              type="button"
              [shape]="'circle'"
              [kind]="'tertiary'"
              [size]="'small'"
              [disabled]="!canGoNextEmbedded"
              (click)="nextEmbeddedPage()"
              class="nav-button nav-right"
              aria-label="Next page"
            >
              <qai-icon kind="chevron-right" positionStart />
            </button>
            <qai-page-indicator
              class="page-indicator"
              [currentPage]="embeddedCurrentPage()"
              [totalPages]="embeddedTotalPages() || 0"
              aria-live="polite"
            />
          }
        } @else {
          <video
            #hostVideo
            class="scorm-embed__video"
            [src]="asset.url"
            controls
            autoplay
            (loadedmetadata)="onHostVideoLoaded(hostVideo)"
            (timeupdate)="onVideoTimeUpdate(hostVideo.currentTime)"
            (seeking)="onHostVideoSeeking(hostVideo)"
            (play)="onHostVideoPlay(hostVideo)"
          ></video>
        }
      </div>
    </div>
  }
</div>
